var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab-content",attrs:{"id":"description"}},[_c('p',{staticClass:"md:px-8 lg:px-24",domProps:{"innerHTML":_vm._s(_vm.description)}})])}
var staticRenderFns = []

export { render, staticRenderFns }